module.exports = __webpack_public_path__ + "static/CalendarMobile-52bfef7b96a80d7208b1d6409d48efe6.mp4";